import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import styles from './emptyBookings.module.css';

const EmptyBookings = ({ online, goToDate, nextAvailable }) => (
  <div className={styles.container}>
    <div className={styles.text}>{online ? 'No appointments available on this date.':'Vensa online booking service is temporarily unavailable.\r\nPlease check back later to book your appointment.\nWe\'re working on getting things back up and running\!'}</div>
    {nextAvailable && online ? (
      <div className={styles.nextAvailable} onClick={goToDate(nextAvailable)}>
        Next Available:
        <span className={styles.date}>
          {moment(nextAvailable).format('dddd, Do MMMM')}
        </span>
      </div>
    ) : null}
  </div>
);

EmptyBookings.propTypes = {
  nextAvailable: PropTypes.string,
  goToDate: PropTypes.func,
  online: PropTypes.bool,
};

export default EmptyBookings;
